.comment-item-wrapper {
  padding: 25px 0 35px 0;
  border-bottom: solid 1px #d4d4d4;
}
.rating-content {
  transform: scale(0.90);
  transform-origin: left top;
}
.comment {
  color: #232323;
  font-size: 14px;
  margin-bottom: 8px;
  width: 100%;
  overflow: hidden;
}
.comment pre {
  white-space: break-spaces;
}
.reviews-info {
  display: flex;
  font-size: 12px;
  column-gap: 4px;
  align-items: center;
}
.user_name {
  font-weight: bold;
  color: #000000;
}
.verified_user {
  color: #1d1d1d;
}
.verified_img {
  width: 10px;
  height: 10px;
  margin-right: 4px;
}
.comment_time {
  color: #282828;
}
.image_gallery {
  margin-top: 20px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.image_gallery .image_gallery_item {
  margin: 4px;
  width: 90px;
  height: 90px;
  border: 1px solid #cacaca;
  border-radius: 9px;
  object-fit: contain;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.image_gallery .image_gallery_item img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

@media screen and (max-width: 1024px) {
  .comment-item-wrapper {
    padding-bottom: 24px;
  }
  .comment pre {
    margin: 0;
    padding: 2px 0;
  }
  .image_gallery {
    margin-top: 12px;
  }
}